
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12.5","cy":"12.5","r":"12.5","fill":"#8CD1D0"}}),_c('path',{attrs:{"stroke":"#fff","stroke-width":"2","stroke-linecap":"round","d":"M13 5v16M5 13h16"}})])
          )
        }
      }
    